/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 16:50:44
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-23 16:52:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/tag.service.ts
 */
import { useState } from 'react';

function useTagService() {
  const [value, setValue] = useState('');
  const onChange = (value) => setValue(value);

  return {
    value,
    onChange,
  };
}

export default useTagService;
